import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import * as postingActions from "../../modules/posting";
import * as tokenActions from "../../modules/token";
import * as settingsActions from "../../modules/settings";

import { axiosWithoutHeaders } from "../../cores/axiosWrapper";
import { parseQueryParameter } from "../../cores";
import { sessionKeeper } from "@cores/sessionKeeper";

const youtubeScope =
    "https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fyoutube%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile";

class LoginPopup extends Component {
    constructor(props) {
        super(props);
        let queryParams;

        const snsKind = props.match.params && props.match.params.snsKind;

        if (props.location.pathname.indexOf("/callback") !== -1) {
            queryParams = parseQueryParameter(this.props.location.search);
        } else {
            queryParams = parseQueryParameter(this.props.location.search);
        }

        this.state = {
            code: queryParams.get("code"),
            clientId: queryParams.get("clientId"),
            snsKind,
        };
    }

    componentDidMount = async () => {
        const { code, snsKind } = this.state;

        try {
            if (!code) {
                window.location = this.generatorYoutubeLoginUrl();
            } else {
                const domain = sessionKeeper.getDomain();
                const tokenData = this.props.TokenActions.getToken(domain);
                this.props.TokenActions.setToken(domain, tokenData);

                const sessionCookie = sessionKeeper.get();

                const settings = await this.props.SettingsActions.getProjectSettings({
                    apiEndpoint: sessionCookie.stageEndpoint,
                    stageId: sessionCookie.stageId,
                    projectId: sessionCookie.projectId,
                    params: { resource: "Posting" },
                });

                const clientId = settings.Posting.youtubeClientId.value;
                const clientSecret = settings.Posting.youtubeClientSecret.value;
                // callback 경로로 들어왔기 때문에 현재 자기 url을 보내주면 redirect URL 임
                const redirectUrl = `${window.location.origin}${window.location.pathname}`;
                const token = await this.getGoogleOauthToken(code, clientId, clientSecret, redirectUrl);
                const tokenInfo = await this.getGoogleTokenInfo(token.id_token);

                const account = {
                    accessToken: token.access_token,
                    refreshToken: token.refresh_token,
                    name: tokenInfo.name,
                    snsId: tokenInfo.sub,
                };

                window.opener.LoginCallbackFunction(snsKind, account);
                // console.log("insertUser code ", decodeURIComponent(this.state.code));
                window.close();
            }
        } catch (e) {
            console.log(e);
        }
    };

    generatorYoutubeLoginUrl = () => {
        const clientId = this.state.clientId;
        const redirectUrl = encodeURIComponent(this.getRedirectUrl());

        return `https://accounts.google.com/o/oauth2/v2/auth?access_type=offline&prompt=consent &scope=${youtubeScope}&response_type=code&client_id=${clientId}&redirect_uri=${redirectUrl}`;
    };

    getRedirectUrl = () => {
        return `${window.location.origin}${window.location.pathname}/callback`;
    };

    getGoogleOauthToken = async (code, clientId, clientSecret, redirectUrl) => {
        const resquestBody = `code=${code}&client_id=${clientId}&client_secret=${clientSecret}&redirect_uri=${redirectUrl}&grant_type=authorization_code`;

        const response = await axiosWithoutHeaders.post(`https://oauth2.googleapis.com/token`, resquestBody, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });

        console.log("getGoogleOauthToken response : ", response);

        return response.data;
    };

    getGoogleTokenInfo = async (idtoken) => {
        const response = await axiosWithoutHeaders.get(`https://oauth2.googleapis.com/tokeninfo`, {
            params: {
                id_token: idtoken,
            },
        });

        console.log("getGoogleTokenInfo response : ", response);

        return response.data;
    };

    render() {
        return (
            <React.Fragment>
                <div></div>
            </React.Fragment>
        );
    }
}

let mapStateToProps = (state) => {
    return {
        stage: state.stage,
        project: state.project,
    };
};

let mapDispatchToProps = (dispatch) => {
    return {
        PostingActions: bindActionCreators(postingActions, dispatch),
        TokenActions: bindActionCreators(tokenActions, dispatch),

        SettingsActions: bindActionCreators(settingsActions, dispatch),
    };
};

const _LoginPopup = connect(mapStateToProps, mapDispatchToProps)(LoginPopup);
export default withTranslation()(withRouter(_LoginPopup));
